import React, { useMemo, useState } from "react";

const RATE_STYLES = {
  wrapper: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    flexWrap: "nowrap",
    verticalAlign: "middle",
  },
  value: {
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
  },
  masked: {
    fontFamily: "monospace",
    letterSpacing: "0.08em",
  },
  button: {
    width: "22px",
    height: "22px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    lineHeight: 1,
    border: "none",
    background: "transparent",
    color: "#243b6b",
    borderRadius: "999px",
    boxShadow: "none",
    transition: "background-color 0.2s ease, color 0.2s ease",
    marginLeft: "2px",
    cursor: "pointer",
  },
  icon: {
    fontSize: "14px",
  },
};

function RateEncryptDecrypt({
  rateData,
  startSymbol = "$",
  endSymbol = "/hr",
  mask = "*******",
  fallbackValue = "0.00",
}) {
  const [showFee, setShowFee] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const numericRate = Number(rateData);
  const hasValidRate = Number.isFinite(numericRate);

  const formattedRate = useMemo(() => {
    if (!hasValidRate) return fallbackValue;
    return numericRate.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }, [fallbackValue, hasValidRate, numericRate]);

  const handleToggle = () => setShowFee((prev) => !prev);
  const buttonLabel = showFee ? "Hide rate" : "Show rate";

  return (
    <span style={RATE_STYLES.wrapper}>
      <span
        style={{
          ...RATE_STYLES.value,
          ...(showFee ? null : RATE_STYLES.masked),
        }}
      >
        {showFee ? `${startSymbol}${formattedRate}${endSymbol}` : mask}
      </span>
      <button
        type="button"
        onClick={handleToggle}
        style={{
          ...RATE_STYLES.button,
          backgroundColor: isHovered ? "rgba(37, 99, 235, 0.12)" : "transparent",
          color: isHovered ? "#1d4ed8" : RATE_STYLES.button.color,
        }}
        aria-label={buttonLabel}
        aria-pressed={showFee}
        title={buttonLabel}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsHovered(true)}
        onBlur={() => setIsHovered(false)}
      >
        <i
          className={showFee ? "fa fa-eye-slash" : "fa fa-eye"}
          style={RATE_STYLES.icon}
          aria-hidden="true"
        />
      </button>
    </span>
  );
}

export default RateEncryptDecrypt;
